import { Navigate } from "react-router-dom";
import { isMobile } from "./capacitor";
import React from "react";

const Atharo = () => {
  const isMobileMode = isMobile();
  return isMobileMode ? (
    <Navigate to="teacherportal" replace={true} />
  ) : (
    <div className="atharo">
      <div className="atharo-logo"></div>
    </div>
  );
};
export default Atharo;
